import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { ContactForm } from '../Forms';
import { Text1 } from '../../../styles';


const ContactModal = (props) => {
    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                {`${props.contact.is_edit ? "Update" : "Create"} Contact`}
            </Text1>
        )
    };

    return (
        <EaseModal
            width={350}
            title={false}
            visible={props.visible}
            onCancel={props.toggleContactModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <ContactForm
                contact={props.contact}
                onSubmit={props.saveContact}
                loading={props.loading}
            />
        </EaseModal>
    )
};

ContactModal.defaultProps = {
    contact: {}
};

export { ContactModal };